import React, {PureComponent} from 'react'
import injectSheet from 'react-jss'
import cn from 'classnames'
import tickImg from "../../img/icons/tick.svg"
import addImg from "../../img/icons/add.svg"
import SVGSymbol from "../SVGSymbol"

class Checkbox extends PureComponent {

    _onChange = (e, value) => {
        const {checked, onChange} = this.props;
        if(onChange) onChange(e, !checked, value);
        e.stopPropagation()
    }

    render() {
        const {classes, className, iconClassName, label, checked, value} = this.props;

        return <div onClick={(e) => this._onChange(e, value)} className={cn(classes.container, {checked}, className)}>
            {checked && <SVGSymbol icon={tickImg} className={cn(classes.icon, iconClassName)} />}
            {!checked && <SVGSymbol icon={addImg} className={cn(classes.icon, iconClassName)} />}
            <div className={classes.label}>{label}</div>
        </div>
    }
}

export default injectSheet( (theme) => ({
    container: {
        display: 'flex',
        flexDirection: ({iconPlacement}) => iconPlacement === 'left' ? 'row-reverse' : 'row',
        cursor: 'pointer',
        color: theme.colors.assent,
        alignItems: 'center',
        "&:hover": {
            color: theme.colors.primary
        },
        ...theme.font.title.h4,
        '&.checked': {
            color: theme.colors.primary
        },
    },
    icon: {
        margin: `-2px ${theme.spacing.tiny} 0`,
        width: 12,
        height: 12,
    },
    label: {
        flexGrow: ({iconPlacement}) => iconPlacement === 'left' ? 1 : 0,
    }
}))(Checkbox)





// WEBPACK FOOTER //
// ./src/components/Widgets/Checkbox.js